module.exports = __webpack_public_path__ + "img/comparisons-table.dfd954d5.svg";